import React, { useState } from 'react';
import { X } from 'lucide-react';
import colors from '../theme/colors';
import { galleryImages } from '../data/mock';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [filter, setFilter] = useState('all');

  const filteredImages = filter === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === filter);

  return (
    <div style={{ backgroundColor: colors.background }} className="min-h-screen">
      {/* Header Section */}
      <section style={{ background: `linear-gradient(135deg, ${colors.white} 0%, ${colors.background} 100%)` }} className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 style={{ color: colors.primary }} className="text-5xl md:text-6xl font-bold mb-6">Our Gallery</h1>
          <p style={{ color: colors.text.medium }} className="text-xl max-w-3xl mx-auto leading-relaxed">
            Browse through our collection of beautiful henna designs and stunning nail art creations.
          </p>
        </div>
      </section>

      {/* Filter Buttons */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex justify-center space-x-4 flex-wrap gap-4">
          {['all', 'henna', 'nails'].map((category) => (
            <button
              key={category}
              onClick={() => setFilter(category)}
              style={{
                backgroundColor: filter === category ? colors.highlight : colors.white,
                color: filter === category ? colors.white : colors.primary,
                borderColor: colors.highlight
              }}
              className="px-6 py-3 rounded-full font-semibold border-2 transition-all duration-300 hover:opacity-90 capitalize"
            >
              {category === 'all' ? 'All' : category === 'henna' ? 'Henna Art' : 'Nail Art'}
            </button>
          ))}
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredImages.map((image) => (
            <div 
              key={image.id}
              onClick={() => setSelectedImage(image)}
              className="relative group cursor-pointer overflow-hidden rounded-xl shadow-lg transition-all duration-300 hover:shadow-2xl hover:scale-[1.03]"
            >
              <div className="aspect-square">
                <img 
                  src={image.url} 
                  alt={image.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div 
                style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center"
              >
                <span className="text-white text-lg font-semibold">View Image</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div 
          onClick={() => setSelectedImage(null)}
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ backgroundColor: 'rgba(0,0,0,0.9)' }}
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 text-white hover:opacity-70 transition-opacity"
          >
            <X size={36} />
          </button>
          <div className="max-w-5xl w-full">
            <img 
              src={selectedImage.url} 
              alt={selectedImage.alt}
              className="w-full h-auto rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;